import React from "react";
import { images } from "src/assets";
import Socials  from "../Socials";
import "./styles.css";

const Footer = () => {
  const _path = window.location.pathname;
  return (
    <div className="ftr" id="ftr" style={{
      display:_path === "/download" ? "none" : ""
    }}>
      <Socials k={3}/>
      <img alt="" src={images.logo_aetherGames} id="logo" />
      <p>© Aether Games Inc 2023. All rights reserved.</p>
      <div id='footer-cookies-tos'>
        <a href="/cookies-policy" target="_blank">Cookies Policy</a>
        <a href="/privacy-policy" target="_blank">Privacy Policy</a>
        <a href="/terms-of-service" target="_blank">Terms Of Service</a>
      </div>
    </div>
  );
};

export default Footer;
